import React, { useEffect } from 'react';
import { Zipy } from './types';
import { ZIPY_IS_ENABLED, ZIPY_PROJECT_ID } from '../../config/env';

const ZIPY_CROSS_ORIGIN = 'anonymous';
const ZIPY_SCRIPT_URL = 'https://cdn.zipy.ai/sdk/v1.0/zipy.min.umd.js';

declare global {
  interface Window {
    zipy: Zipy;
  }
}

const SetupZipy: React.FC = () => {
  useEffect(
    () => {
      if (!(ZIPY_IS_ENABLED && ZIPY_PROJECT_ID)) {
        return;
      }

      const script = document.createElement('script');
      script.crossOrigin = ZIPY_CROSS_ORIGIN;
      script.src = ZIPY_SCRIPT_URL;
      script.async = true;

      script.onload = () => {
        if (window.zipy) {
          console.log('Zipy initialized');
          window.zipy.init(ZIPY_PROJECT_ID!);
        }
      };

      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return null;
};

export default SetupZipy;
